// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.
import { createSignal } from "solid-js";

type ExpiredSession = { slot: number };
const [expiredSession, setExpiredSession] = createSignal<ExpiredSession>();

export { expiredSession };

export function markSessionExpired(slot: number) {
  setExpiredSession({ slot });
}

export function restoreSession(slot: number) {
  if (expiredSession()?.slot === slot) setExpiredSession();
}
